import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { EnhancedTabs } from '@swyftx/aviary/molecules/EnhancedTabs';

import { Asset } from '@shared/api';

import { useCountryAsset } from '@hooks/Assets/useCountryAsset';
import { TransactionHistoryTab } from '@routes/Transactions/types';

import { observer } from 'mobx-react-lite';
import { useSwyftxMargin } from 'src/lib/margin/hooks/useSwyftxMargin';

type Props = {
  value: TransactionHistoryTab;
  filterAsset?: Asset;
  onChange: (newValue: TransactionHistoryTab) => void;
};

const TransactionsTabs: React.FC<Props> = observer(({ value, filterAsset, onChange }) => {
  const { swyftxMarginEnabled } = useSwyftxMargin();
  const countryAsset = useCountryAsset();
  const { t } = useTranslation('orders');

  return (
    <FlexLayout className='w-full border-b border-color-border-main p-12'>
      <EnhancedTabs<TransactionHistoryTab>
        tabs={[
          {
            title: t('transactionsTabs.buttonLabels.orders'),
            value: 'orders',
          },
          {
            title: t('transactionsTabs.buttonLabels.deposits'),
            value: 'deposits',
          },
          {
            title: t('transactionsTabs.buttonLabels.withdrawals'),
            value: 'withdrawals',
          },
          {
            title: t('transactionsTabs.buttonLabels.transfers'),
            value: 'transfers',
            hidden: !swyftxMarginEnabled || (filterAsset && filterAsset.id !== countryAsset?.id),
          },
        ]}
        value={value}
        onChange={onChange}
        size='md'
      />
    </FlexLayout>
  );
});

export { TransactionsTabs };
